import styled from 'styled-components';

import { Button } from '../../../components/atoms/button/button';
import { Modal } from '../../../components/molecules/modal/modal';

interface Props {
  isOpen: boolean;
  titulo: string;
  loading?: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

const Body = styled.p`
  margin: 0;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.textPrimary};
  line-height: 1.5;
`;

const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
`;

export const ConfirmarDesativarModal = ({
  isOpen,
  titulo,
  loading,
  onConfirm,
  onClose,
}: Props) => (
  <Modal
    isOpen={isOpen}
    onClose={loading ? () => undefined : onClose}
    title="Desativar aviso?"
    description="O aviso deixará de ser exibido na plataforma imediatamente."
    size="sm"
    footer={
      <Footer>
        <Button variant="ghost" onClick={onClose} disabled={loading}>
          Cancelar
        </Button>
        <Button
          variant="danger"
          onClick={onConfirm}
          loading={loading}
          data-testid="confirmar-desativar-aviso"
        >
          Desativar
        </Button>
      </Footer>
    }
  >
    <Body>
      Confirmar desativação de <strong>{titulo}</strong>?
    </Body>
  </Modal>
);
